module.exports = {
      id: "srilanka-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#srilanka-usage",
      toString: function () {
        return this.url;
      }
    }